import { UploaddocumentClientRequest } from '../../../@types/UploadDocument'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useDocumentStore } from '../../../Stores/useDocumentStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'

export const useUploadDocumentPayload = () => {
  const { runPetisSimulation } = useRunPetisSimulationStore()
  const { createProposal } = useCreateProposalStore()
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const { documents, switchAttachment } = useDocumentStore()

  const runPetis = runPetisSimulation?.runPetisSimulationResponse

  const uploadDocumentPayload = (context: string) => {
    return {
      documents: switchAttachment[context]
        ? documents.map((_document) => {
            return {
              uploadBy: _document.uploadBy,
              number: _document.number,
              docType: _document.docType,
              file: _document.file,
              fileDescription: _document.fileDescription,
              user: _document.user,
            }
          })
        : [],
      policy: {
        policyId: createProposal?.createProposalResponse?.proposalId,
        policyHolder: {
          fiscalNumber: Number(policyholderDetailsSelected?.vatNumber),
        },
        productData: {
          company: runPetis?.productData?.company,
        },
      },
    } as UploaddocumentClientRequest
  }
  return {
    uploadDocumentPayload,
  }
}
